import { CashflowProvider } from '../../api/cashflow';

// "123123.45" → "123 123,45" (пробел — разряды, запятая — копейки)
export function formatMoney(value: number): string {
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0);
}

// Парсинг ввода: "123 123,45" / "123123.45" → 123123.45 (или null если мусор)
export function parseMoney(input: string): number | null {
  const normalized = input.replace(/\s/g, '').replace(',', '.');
  if (!normalized) return null;
  const n = Number(normalized);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 100) / 100;
}

export const PROVIDER_LABELS: Record<CashflowProvider, string> = {
  click: 'Click',
  payme: 'Payme',
  paylov: 'Paylov',
};

export const PROVIDER_COLORS: Record<CashflowProvider, string> = {
  click: '#0EA5A4',
  payme: '#6366F1',
  paylov: '#F59E0B',
};

export const PROVIDER_ORDER: CashflowProvider[] = ['click', 'payme', 'paylov'];

export function formatPercent(commission: number): string {
  // 0.015 → "−1.5%"
  const pct = commission * 100;
  const str = Number.isInteger(pct) ? String(pct) : pct.toFixed(1);
  return `−${str}%`;
}
